import axiosInstance from "../utils/axios";

export const ListAppBuilds = async (values) => {
    return await axiosInstance().post("admin/app-build/list", values);
}

export const DownloadAppBuild = async (id) => {
    return await axiosInstance().get(`admin/app-build/download/${id}`, { responseType: 'blob' });
}

export const DeleteAppBuild = async (id) => {
    return await axiosInstance().post(`admin/app-build/delete/${id}`);
}

export const SetAppBuildApproval = async (id, is_approved) => {
    return await axiosInstance().post(`admin/app-build/set-approval/${id}`, { is_approved });
}
